module.exports = __webpack_public_path__ + "media/images/favicon-3be376012eed4530ebaa9c6dd9a0d392.png";